"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import UserPageFollowers from "../followers/UserPageFollowers";
import { Tooltip } from "react-tooltip";
const SAFE_ROUTE_SEGMENT_PATTERN = /^[a-zA-Z0-9._-]+$/;
function sanitizeRouteSegment(value: string): string | null {
  if (!value) {
    return null;
  }
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return null;
  }
  const normalizedValue = trimmedValue.toLowerCase();
  if (!SAFE_ROUTE_SEGMENT_PATTERN.test(normalizedValue)) {
    return null;
  }
  return encodeURIComponent(normalizedValue);
}
export default function UserPageHeaderStats(t0) {
  const $ = _c(37);
  const {
    profile,
    handleOrWallet,
    followersCount
  } = t0;
  let t1;
  if ($[0] !== handleOrWallet) {
    t1 = sanitizeRouteSegment(handleOrWallet);
    $[0] = handleOrWallet;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const routeHandle = t1;
  if (!routeHandle) {
    return null;
  }
  const t2 = `/${routeHandle}/collected`;
  let t3;
  if ($[2] !== profile.tdh) {
    t3 = formatNumberWithCommas(profile.tdh);
    $[2] = profile.tdh;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span className="tw-text-base tw-font-semibold tw-text-iron-50">{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="tw-block tw-text-base tw-font-medium tw-text-iron-400">TDH</span>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t4) {
    t6 = <Link href={t2} className="tw-no-underline tw-inline-flex tw-items-center tw-gap-x-1 desktop-hover:hover:tw-underline tw-transition tw-duration-300 tw-ease-out">{t4}{t5}</Link>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `/${routeHandle}/stats?activity=tdh-history`;
  let t8;
  if ($[10] !== profile.tdh_rate) {
    t8 = formatNumberWithCommas(profile.tdh_rate);
    $[10] = profile.tdh_rate;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <span className="tw-text-base tw-font-semibold tw-text-iron-50">{t8}</span>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="tw-block tw-text-base tw-font-medium tw-text-iron-400 tw-whitespace-nowrap">TDH Rate</span>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t7 || $[16] !== t9) {
    t11 = <Link href={t7} className="tw-no-underline tw-inline-flex tw-items-center tw-gap-x-1 desktop-hover:hover:tw-underline tw-transition tw-duration-300 tw-ease-out" data-tooltip-id="tdh-rate-tooltip">{t9}{t10}</Link>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = `/${routeHandle}/rep`;
  let t13;
  if ($[18] !== profile.rep) {
    t13 = formatNumberWithCommas(profile.rep);
    $[18] = profile.rep;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13) {
    t14 = <span className="tw-text-base tw-font-semibold tw-text-iron-50">{t13}</span>;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="tw-block tw-text-base tw-font-medium tw-text-iron-400">Rep</span>;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t12 || $[24] !== t14) {
    t16 = <Link href={t12} className="tw-no-underline tw-inline-flex tw-items-center tw-gap-x-1 desktop-hover:hover:tw-underline tw-transition tw-duration-300 tw-ease-out">{t14}{t15}</Link>;
    $[23] = t12;
    $[24] = t14;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== followersCount || $[27] !== routeHandle) {
    t17 = <UserPageFollowers handleOrWallet={routeHandle} followersCount={followersCount} />;
    $[26] = followersCount;
    $[27] = routeHandle;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t11 || $[30] !== t16 || $[31] !== t17 || $[32] !== t6) {
    t18 = <div className="tw-flex tw-gap-x-4 sm:tw-gap-x-6 tw-flex-wrap tw-gap-y-2">{t6}{t11}{t16}{t17}</div>;
    $[29] = t11;
    $[30] = t16;
    $[31] = t17;
    $[32] = t6;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Tooltip id="tdh-rate-tooltip" place="top" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}><span className="tw-text-xs">How much TDH you earn each day</span></Tooltip>;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t18) {
    t20 = <div className="tw-mt-3">{t18}{t19}</div>;
    $[35] = t18;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  return t20;
}